import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import { Pagination, Heading, ResultByCompany, UserSearchbox, NotFound, Loader } from 'components'
import { productActions, orderActions, userActions } from 'redux/actionCreators'
import classes from './PriceTable.scss'

// Lodash
import { get, omit, isEqual, pickBy, identity } from 'lodash'
import { pageFromProps, offset } from 'helpers/utilities'
import queryString from 'query-string'

@connect((state) => ({
  searchState: get(state, ['app', 'searchState']),
  prices: get(state, ['product', 'prices']) || {},
  loading: get(state, 'product.pricesAttempting') || false,
  productCode: get(state, 'product.product.productCode') || '',
  pageCount: get(state, ['product', 'pageCount']) || 0,
  bannerMap: get(state, ['banner', 'bannerMap']) || {},
  cartProductMap: get(state, ['order', 'cartProductMap']) || {},
  companyOptions: get(state, ['company', 'companyOptions']) || [],
  tagOptions: get(state, ['product', 'tagOptions']) || [],
  userClass: get(state, ['user', 'me', 'userClass']) || 0,
  aggregateResult: get(state, 'product.aggregateResult') || []
}), (dispatch, ownProps) => ({
  saveSearchState: (searchState) =>
    dispatch({ type: 'SAVE_SEARCH_STATE', searchState }),
  attemptFindPrices: (payload = {}) =>
    dispatch(productActions.attemptFindPrices({
      ...payload,
      groupBy: 'companyCode',
      offset: payload.offset,
      limit: 100
    })),
  attemptAggregate: (payload = {}) =>
    dispatch(productActions.attemptAggregate(payload)),
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload)),
  attemptAddToWishlist: (productCode) =>
    dispatch(userActions.attemptAddToWishlist({ productCode })),
  attemptRemoveFromWishlist: (productCode) =>
    dispatch(userActions.attemptRemoveFromWishlist({ productCode }))
}))
class PriceTable extends Component {
  state = {
    currentQuery: {
      barcode: '',
      genericName: '',
      productCode: '',
      productName: ''
    }
  };
  static propTypes = {
    prices: PropTypes.object.isRequired,
    pageCount: PropTypes.number.isRequired,
    bannerMap: PropTypes.object.isRequired,
    cartProductMap: PropTypes.object.isRequired,
    companyOptions: PropTypes.array.isRequired,
    tagOptions: PropTypes.array.isRequired,
    userClass: PropTypes.number.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentDidMount () {
    window.objectFitImages()
    if (this.props.productCode) {
      setTimeout(() => {
        const row = document.getElementById(this.props.productCode)
        if (!row) return
        const { top } = offset(row)
        window.scrollTo(0, top - 200)
      }, 500)
    }
  }

  componentWillMount () {
    const query = {
      barcode: get(this.props, 'location.query.keyword'),
      productCode: get(this.props, 'location.query.keyword'),
      productName: get(this.props, 'location.query.keyword'),
      description: get(this.props, 'location.query.keyword'),
      genericName: get(this.props, 'location.query.keyword'),
      companyCode: get(this.props, 'location.query.companyCode'),
      category: get(this.props, 'location.query.category'),
      offset: (pageFromProps(this.props) - 1) * 100
    }
    this.props.attemptFindPrices(query)
    this.props.attemptAggregate(query)
  }

  _cleanQuery = (query) =>
    omit(pickBy(query, identity), ['page', 'offset']);

  _onQuery = (query) => {
    const { pathname } = this.props.location
    const { keyword, companyCode, category, page } = query
    const fields = pickBy({ keyword, companyCode, category, page }, identity)
    if (!isEqual(this._cleanQuery(this.state.currentQuery), this._cleanQuery(query))) {
      this.setState({ currentQuery: query })
      this.context.router.push(`${pathname}?${queryString.stringify({ ...fields, page: 1 })}`)
    } else {
      this.context.router.push(`${pathname}?${queryString.stringify(fields)}`)
    }

    this.props.attemptFindPrices(query)
    this.props.attemptAggregate(query)
  }

  render () {
    const { searchState, prices, loading, pageCount, location, bannerMap, aggregateResult, companyOptions, tagOptions } = this.props
    return (
      <section className={classes.priceTable}>
        <Helmet title='ตารางราคา' />
        {get(bannerMap, ['price-banner1', 'path']) && (
          <div className={classes.banner}>
            <a href={get(bannerMap, ['price-banner1', 'link'])}>
              <img src={`${get(bannerMap, ['price-banner1', 'path'])}?v=${get(bannerMap, ['price-banner1', 'version'])}`} alt={get(bannerMap, ['price-banner1', 'title'])} />
            </a>
          </div>
        )}
        <Heading withSearchbox>ตารางราคา</Heading>
        <UserSearchbox
          searchState={searchState}
          onSearchStateSave={this.props.saveSearchState}
          onQuery={this._onQuery}
          query={location.query}
          offset={(pageFromProps(this.props) - 1) * 100}
          companyOptions={companyOptions}
          tagOptions={tagOptions}
          aggregateResult={aggregateResult} />
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        {pageCount ? (
          <div>
            {Object.keys(prices).map(key =>
              <ResultByCompany
                key={key}
                title={key}
                products={prices[key]} />
            )}
            {/* Object.keys(prices).map(key =>
              <ResultByCompany key={key} title={key}
                products={prices[key]}
                onAddToCart={attemptAddToCart}
                onAddToWishlist={attemptAddToWishlist}
                onRemoveFromWishlist={attemptRemoveFromWishlist}
                cartProductMap={cartProductMap}
                userClass={userClass} />
            ) */}
          </div>
        ) : !loading ? <NotFound /> : <Loader blue />}
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
      </section>
    )
  }
}

export default PriceTable



/** WEBPACK FOOTER **
 ** ./src/containers/User/PriceTable/PriceTable.js
 **/